import {createSelector} from '@ngrx/store';

import * as fromCitizensServicesAutomationDetails from './citizens-services-automation-details.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizensServicesAutomationDetails.citizensServicesAutomationDetailsesFeatureKey]);

export const selectCitizenServiceAutomation = createSelector(currentState, fromCitizensServicesAutomationDetails.selectAll);

export const selectTotalCitizenServicesAutomation = createSelector(currentState, fromCitizensServicesAutomationDetails.selectTotal);

export const selectModifiedCitizenServicesAutomation = createSelector(selectCitizenServiceAutomation, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen
    };
  });
});



